import Model from "../../model"
import { ID, Project } from "../../types"

import Command, { CommandName } from "../command"
import DeleteProjectCommand from "./delete_project_command"

export type CreateProjectCommandState = {
  id: ID
  project: Project
}

export default class CreateProjectCommand extends Command {
  name: CommandName = "create-project"
  state: CreateProjectCommandState

  constructor(state: CreateProjectCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //  - none
  resolveConflicts(_model: Model): CreateProjectCommandState {
    return this.state
  }

  local(model: Model): any {
    model.createProject(this.state.id, this.state.project)
  }

  undo(): Command[] {
    return [new DeleteProjectCommand({ id: this.state.id })]
  }
}
